import Cookies from 'js-cookie';

export const formatDateTime = (dateTime) => {
  if (!dateTime) {
    return 'Unknown';
  }
  try {
    const dateObject = new Date(dateTime);
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      hourCycle: 'h11'
    });
    return dateFormatter.format(dateObject).replace(',', '');
  } catch {
    // for when date is absent or invalid
    return 'Unknown';
  }
};

export const isNativeApp = (win = window) => {
  return typeof window === 'undefined' ? false : win.__EXPERIENCE_CONTEXT__?.isConsumerApp;
};

export const getUrlParam = (key, win = window) => {
  const searchParams = (typeof win !== 'undefined') ? win?.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const getTMXSessionID = (win = window) => {
  const nativeTMXprofileId = getUrlParam('guid', win);
  if (isNativeApp(win) && nativeTMXprofileId) {
    return nativeTMXprofileId;
  }
  return typeof win === 'undefined' ? '' : win?.THD_ACCOUNT_LIB?.TMX?.sessionId;
};

export const activityLogEnabled = () => {
  const FS = 'ENABLE_ACCOUNT_ACTIVITY_LOG';
  return typeof window !== 'undefined' && (Cookies.get(FS)
          || window.__EXPERIENCE_PROPS__?.expConfiguration[FS] === 'true'
          // eslint-disable-next-line eqeqeq
          || window.__EXPERIENCE_PROPS__?.expConfiguration[FS] == '1');
};

export function formatTheGivenInput(city) {
  if (!city || city === '') return '';
  return city
    .trim()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word?.toLowerCase().slice(1))
    .join(' ');
}

export const locationDetails = (device) => {
  const checkProp = (prop) => (!prop || prop === '' ? 'Unknown' : prop);
  const city = checkProp(formatTheGivenInput(device?.location?.city));
  const country = checkProp(device?.location?.country);
  const region = checkProp(device?.location?.region?.toUpperCase());

  if (city === 'Unknown' && region === 'Unknown') {
    return {
      region: 'Unknown',
      country: country === 'Unknown' ? 'Unknown' : country
    };
  }
  return {
    region: `${city}, ${region}`,
    country
  };
};

export const getDeviceVersion = (browserVersion) => {
  const parts = browserVersion.match(/\d+/g);
  if (parts && parts.length > 0) {
    const version = parts.join('.');
    return version;
  }
  return '';

};

export const deviceDetails = (device) => {
  const checkProp = (prop) => (!prop || prop === '' ? 'Unknown' : prop);
  const os = checkProp(device?.os?.type);
  const browser = checkProp(device?.browser?.type);
  const formattedVersion = getDeviceVersion(checkProp(device?.os?.version));

  if (os === 'Unknown' && browser === 'Unknown') {
    return {
      os: 'Unknown',
      version: '',
      browser: ''
    };
  }
  return { os, version: formattedVersion, browser };
};

export const formatBrowser = (browser) => {
  try {
    if (!browser) {
      return '';
    }
    const parts = browser.split(/[\s_-]+/);
    if (parts.length >= 0) {
      return parts.slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .reduce((acc, element) => acc + ' | ' + element, '');
    }
  } catch (error) {
    console.log('Error in formatting browser');
  }
  return '';
};

export const getReportedDate = (reportedTs) => {
  if (!reportedTs) {
    return 'Unknown';
  }
  try {
    const timestamp = Number(reportedTs);
    const dateObject = new Date(timestamp);
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      hourCycle: 'h11'
    });
    return dateFormatter.format(dateObject).replace(',', '');
  } catch {
    // for when date is absent or invalid
    return 'Unknown';
  }
};

/**
 * This function pushes the event object in the window.digital Object.
 */
export function eventReady(obj) {
  try {
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(obj);
    if (
      typeof localStorage !== 'undefined'
      && localStorage.getItem('AnalyticsDebug')
    ) {
      console.log('[Analytics event] ', obj);
    }
  } catch (error) {
    console.error('GlobalDDO event push failed', error);
  }
}

export const checkFSEnabled = (feature) => {
  if (typeof window === 'undefined') return false;
  return (
      window.__EXPERIENCE_PROPS__?.expConfiguration[feature] === 'true'
      // eslint-disable-next-line eqeqeq
      || window.__EXPERIENCE_PROPS__?.expConfiguration[feature] == '1'
  );
};
